<template>
  <b-container class="the-detail the-detail--site" fluid v-bind:class="{'detail-visible': showDetailPage}">
    <b-row>
      <b-col class="the-detail__sitelist" col lg="3" xl="2">
        <site-detail-sitelist />
      </b-col>
      <b-col class="the-detail__siteitem" col lg="9" md="12" xl="10">
        <site-detail-head />
        <site-detail-tags />
        <b-tabs>
          <b-tab title="Dashboard"><site-detail-dashboard/></b-tab>
          <b-tab title="Extensions"><site-detail-extensions/></b-tab>
          <b-tab title="Backups"><site-detail-backups/></b-tab>
          <b-tab title="Update Sites" v-if="siteDetail.data.app_type === 'Joomla'"><site-detail-updatesites/></b-tab>
          <b-tab title="Schedule"><site-detail-schedule/></b-tab>
          <b-tab lazy title="Performance"><site-detail-performance /></b-tab>
          <b-tab title="Security Checks"><site-detail-auditdashboard/></b-tab>
          <b-tab title="Settings"><site-detail-settings /></b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import { mapState } from 'vuex'

import SiteDetailBackups from './SiteDetailBackups'
import SiteDetailUpdatesites from './SiteDetailUpdatesites'
import SiteDetailDashboard from './SiteDetailDashboard'
import SiteDetailExtensions from './SiteDetailExtensions'
import SiteDetailHead from './SiteDetailHead'
import SiteDetailSchedule from './SiteDetailSchedule'
import SiteDetailSitelist from './SiteDetailSitelist'
import SiteDetailPerformance from './SiteDetailPerformance'
import SiteDetailAuditdashboard from './SiteDetailAuditdashboard'
import SiteDetailSettings from './SiteDetailSettings'
import SiteDetailTags from '@/components/Sites/SiteDetailTags.vue'

export default {

  name: 'SiteDetail',

  components: {
    SiteDetailTags,
    SiteDetailAuditdashboard,
    SiteDetailSettings,
    SiteDetailPerformance,
    SiteDetailSitelist,
    SiteDetailDashboard,
    SiteDetailBackups,
    SiteDetailUpdatesites,
    SiteDetailExtensions,
    SiteDetailHead,
    SiteDetailSchedule
  },

  computed: {
    ...mapState('site', [
      'siteDetail',
      'showDetailPage',
      'showDetailPageBackups',
      'showDetailPageExtensions',
      'showDetailPageConfiguration',
      'sideDetailsLoading'
    ]),

    showDetailPageDefault () {
      return this.showDetailPage &&
      !this.showDetailPageBackups &&
      !this.showDetailPageExtensions &&
      !this.showDetailPageConfiguration
    }
  }
}
</script>
